const awsConfiguration = {
  region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_VFb4QPsHu",
  ClientId: "607hojd1n1cifejqa3gjabegb0"
}
export default awsConfiguration
